<h2 mat-dialog-title>Invite New User</h2>

<mat-dialog-content>
  <form [formGroup]="inviteForm" class="invite-form">

    <div class="row">
      <div class="col-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>First Name</mat-label>
          <input matInput formControlName="firstName" placeholder="Jane" />
          <mat-error *ngIf="inviteForm.get('firstName')?.hasError('required')">
            First name is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Last Name</mat-label>
          <input matInput formControlName="lastName" placeholder="Smith" />
          <mat-error *ngIf="inviteForm.get('lastName')?.hasError('required')">
            Last name is required
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Email Address</mat-label>
      <input matInput formControlName="email" type="email" placeholder="jane@example.com" />
      <mat-icon matSuffix>email</mat-icon>
      <mat-error *ngIf="inviteForm.get('email')?.hasError('required')">Email is required</mat-error>
      <mat-error *ngIf="inviteForm.get('email')?.hasError('email')">Enter a valid email</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Role</mat-label>
      <mat-select formControlName="role">
        <mat-option *ngFor="let role of roles" [value]="role" class="text-capitalize">
          {{role}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="inviteForm.get('role')?.value === 'recruiter'" appearance="outline" class="w-100">
      <mat-label>Organization Name</mat-label>
      <input matInput formControlName="organizationName" placeholder="Acme Corporation" />
      <mat-icon matSuffix>business</mat-icon>
      <mat-error *ngIf="inviteForm.get('organizationName')?.hasError('required')">
        Organization name is required for recruiters
      </mat-error>
    </mat-form-field>

    <!-- Error banner -->
    <div *ngIf="errorMessage" class="alert alert-danger py-2 mt-1">
      {{errorMessage}}
    </div>

  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()" [disabled]="submitting">Cancel</button>
  <button mat-raised-button color="primary"
          (click)="submit()"
          [disabled]="inviteForm.invalid || submitting">
    <mat-spinner *ngIf="submitting" diameter="18" class="d-inline-block me-1"></mat-spinner>
    {{ submitting ? 'Setting up...' : (invitedRecruiterUserId ? 'Retry Organization Setup' : 'Send Invite') }}
  </button>
</mat-dialog-actions>
